import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import _ from 'lodash';
import { FileLocationAdapter } from './file-location.adapter';
import { SftpLocation } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SftpLocation)
})
export class SftpLocationAdapter extends FileLocationAdapter<SftpLocation, Model.DatasetLocation> {
    public _toResource(store: SftpLocation): Model.SftpLocation {
        const resource: Model.SftpLocation = {
            type: 'SftpLocation',
            fileName: ValueAdapter.toResource(store, SftpLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, SftpLocation.FOLDER_PATH) || undefined
        };
        // need append / for folder path
        const folderPath = resource.folderPath;
        if (_.isString(folderPath) && folderPath.charAt(0) !== '/') {
            resource.folderPath = '/' + folderPath;
        }
        return resource;
    }

    public _toModel(resource: Model.SftpLocation, owner: Named): SftpLocation {
        const model = Owned.create<SftpLocation>(SftpLocation.MODEL, owner);
        ValueAdapter.toModel(model, SftpLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, SftpLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
